import BaseRequestService from "./base-request-service";

class products extends BaseRequestService {
    getNavigation = () => this.getRequest('api/navigation')
}

export default new products();